module.exports = __webpack_public_path__ + "static/media/unknownImage.d2f7507d.jpeg";